import React from "react";
import {Col, Row, Typography} from "antd";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import moment from 'moment';
import {DATE_TIME_FORMAT} from "@config/constants";

const {Title, Text} = Typography;
const FinishedBid = ({product}) => {
  const {t} = useTranslation();
  let {cp_id} = useParams();
  return (
    <Row>
      {cp_id ? (
        <Col xs={24}>
          <Row justify={{ xs: 'start', sm: 'start', md: 'center', lg: 'center' }}>
            <Col xs={24} md={24}>
              <Text
                className="page-block-product-upcoming-title split-item">{t("product.round_start")} {moment(product?.start_time).format(DATE_TIME_FORMAT)}</Text>
            </Col>
            <Col xs={24} md={24}>
              <Text
                className="page-block-product-upcoming-title">{t("product.round_end")} {moment(product?.end_time).format(DATE_TIME_FORMAT)}</Text>
            </Col>
          </Row>
        </Col>
      ) : (
        <>
          <Col xs={24} md={24}>
            <Title level={5} className="page-block-product-upcoming-title">{t("product.round_start")}</Title>
            <Text className="page-block-product-upcoming-date">{moment(product?.start_time).format(DATE_TIME_FORMAT)}</Text>
          </Col>
          <Col xs={24} md={24}>
            <Title level={5} className="page-block-product-upcoming-title">{t("product.round_end")}</Title>
            <Text className="page-block-product-upcoming-date">{moment(product?.end_time).format(DATE_TIME_FORMAT)}</Text>
          </Col>
        </>
      )}
    </Row>
  );
};

export default FinishedBid;

